export default function WidgetTile({
  title,
  value,
  subtext,
  icon: Icon,
  colorScheme = "purple", // "purple" | "rose" | "amber" | "emerald" | "coral" | "violet" | "blue"
  onClick,
  active = false,
  badge
}) {
  // Validate data strictly: no dummy data
  let displayValue = null;
  if (value !== undefined && value !== null) {
    if (typeof value === "number") {
      displayValue = Number.isNaN(value) ? "0" : value.toLocaleString("en-IN", { maximumFractionDigits: 2 });
    } else {
      displayValue = String(value);
    }
  }

  return (
    <div
      className={`widget-tile widget-tile--${colorScheme}${active ? " active" : ""}${onClick ? " clickable" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="widget-tile__icon-box">
        {Icon && <Icon />}
      </div>
      <div className="widget-tile__content">
        <div className="widget-tile__top-row">
          <span className="widget-tile__title">{title}</span>
          {badge && <span className="widget-tile__badge">{badge}</span>}
        </div>
        {displayValue !== null && (
          <div className="widget-tile__value">{displayValue}</div>
        )}
        {subtext && (
          <div className="widget-tile__subtext">{subtext}</div>
        )}
      </div>
    </div>
  );
}
